const fields = document.querySelectorAll('.floating-field input, .floating-field  textarea');
const toggleLabel = (field) => {
    if (field.value === '') {
        field.parentElement.classList.remove('field--show-floating-label');
    }
    else {
        field.parentElement.classList.add('field--show-floating-label');
    }
};
if (fields.length > 0) {
    [...fields].forEach((field) => {
        if (field.value !== '') {
            field.parentElement.classList.add('field--show-floating-label');
        }
        field.addEventListener('keyup', (e) => {
            const target = e.target;
            toggleLabel(target);
        });
        field.addEventListener('change', (e) => {
            const target = e.target;
            toggleLabel(target);
        });
    });
}
